import React from 'react';
import {Link} from 'react-router-dom';
import {Grid, Card, Loader} from 'semantic-ui-react';
import InfiniteScroll from 'react-infinite-scroll-component';
import _ from 'lodash';
import {toStartCase} from 'common/utils';

const OrganizationSummaryCard = ({
  orgId,
  results,
  fetchMoreData,
  hasMore,
  nameLabel,
  addressLabel,
  numberLabelOne,
  numberLabelTwo,
  actionLabel,
  isUserAOR,
  registeredLabel,
  formatSAM,
  isOrgAOR,
  isOrgProgAOR,
  dunsToUEIToggle,
}) => {
  const cards = _.map(results, (result, index) => {
    return (
      <Card key={index} fluid>
        <Grid celled="internally">
          <Grid.Column id="suborg-section1" width={4}>
            <strong>{nameLabel}</strong>
            <p>{toStartCase(_.toLower(result.displayName))}</p>
          </Grid.Column>
          <Grid.Column id="suborg-section2" width={8}>
            <Grid columns={2}>
              <Grid.Column style={{paddingLeft: '40px'}}>
                <strong>{addressLabel}</strong>
                <p>
                  {toStartCase(_.toLower(result.mailingAddress.addressLine1))} <br />
                  {toStartCase(_.toLower(result.mailingAddress.city))},{' '}
                  {result.mailingAddress.stateOrProvince} {result.mailingAddress.zip}
                </p>
                <strong>{registeredLabel}</strong>
                <p>{formatSAM(result.isManuallyAdded)}</p>
              </Grid.Column>
              <Grid.Column>
                <strong>{numberLabelOne}</strong>
                {dunsToUEIToggle ? (
                  <p>
                    {result.uei ? result.uei : null}
                    {result.uei && result.eft && _.trim(result.eft) != ''
                      ? '-' + result.eft
                      : null}
                  </p>
                ) : (
                  <p>
                    {result.duns ? result.duns : null}
                    {result.eft && result.eft.trim().length ? result.eft : null}
                  </p>
                )}
                <br />
                <strong>{numberLabelTwo}</strong>
                  <p>
                    {result.duns ? result.duns : null}
                    {result.eft && result.eft.trim().length ? result.eft : null}
                  </p>
              </Grid.Column>
            </Grid>
          </Grid.Column>
          <Grid.Column id="suborg-section3" width={4}>
            <Grid.Column textAlign="left">
              <strong>{actionLabel}</strong>
              <br />
              {isUserAOR && (isOrgAOR || isOrgProgAOR) ? (
                <Link
                  label="manage"
                  title={`manage ${result.displayName}`}
                  id="manageOrganization"
                  to={`/subOrganization/${orgId}/${result.organizationId}`}
                >
                  Manage
                </Link>
              ) : (
                <Link
                  label="view"
                  title={`view ${result.displayName}`}
                  id="viewOrganization"
                  to={`/subOrganization/${orgId}/${result.organizationId}`}
                >
                  View
                </Link>
              )}
            </Grid.Column>
          </Grid.Column>
        </Grid>
      </Card>
    );
  });

  return (
    <InfiniteScroll
      className="ui cards"
      dataLength={cards.length}
      next={fetchMoreData}
      hasMore={hasMore}
      scrollableTarget={'root'}
      loader={
        <Loader inline="centered" active>
          Loading...
        </Loader>
      }
    >
      {cards}
    </InfiniteScroll>
  );
};

export default OrganizationSummaryCard;
